module.exports = __webpack_public_path__ + "static/img/smile_1.2db3d57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/smile_1.png
// module id = FyPj
// module chunks = 25